<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <path fill="#343A40" d="M361.56,271.3V393.22a31.67,31.67,0,0,1-31.67,31.67H97.67A31.67,31.67,0,0,1,66,393.22V161a31.67,31.67,0,0,1,31.67-31.67H261.28A15.82,15.82,0,0,1,272.47,134L283,144.53c10,10,2.91,27-11.2,27H108.22V382.67H319.33V281.86a15.84,15.84,0,0,1,4.64-11.2l10.56-10.55C344.5,250.13,361.56,257.2,361.56,271.3ZM446,111.74a24.63,24.63,0,0,0-24.63-24.63H316.69a18.47,18.47,0,0,0-18.47,18.47v11.8a18.48,18.48,0,0,0,19,18.47l44.34-1.26-164.2,163a15.84,15.84,0,0,0,0,22.43l15.76,15.76a15.83,15.83,0,0,0,22.43,0l163-164.2-1.26,44.34a18.48,18.48,0,0,0,18.47,19h11.8A18.47,18.47,0,0,0,446,216.42Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdExternalLinkIcon',
        components: {
            MdIcon
        }
    }
</script>
